{
  "version": 1,
  "asset_id": "84b6c4b0-0e95-4b79-a5d1-29d43c8b6cff",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/84b6c4b0-0e95-4b79-a5d1-29d43c8b6cff/hiatal-type-4-v2-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/84b6c4b0-0e95-4b79-a5d1-29d43c8b6cff/hiatal-type-4-v2-1200.webp",
  "original_filename": "hiatal-type-4-v2-1200.webp",
  "size": 156588,
  "content_type": "image/webp",
  "created_at": "2026-09-24T19:31:02Z"
}
